import { POLSUMMARY_INIT_LOADING, POLSUMMARY_INIT_SUCCESS, POLSUMMARY_INIT_FAIL, PREMINSTALBILL_SAVE_LOADING, PREMINSTALBILL_SAVE_SUCCESS, PREMINSTALBILL_SAVE_FAIL } from '@/store/types'

export const summary = {
  [POLSUMMARY_INIT_LOADING](state) {
    state.policySummarySettings.init = 0
    state.policySummarySettings.initErr = []
    state.policySummarySettings.menu = {}
  },
  [POLSUMMARY_INIT_SUCCESS](state, data) {
    state.policySummarySettings.init = 1
    state.policySummarySettings.initErr = []
    state.policySummarySettings.menu = data.menu
  },
  [POLSUMMARY_INIT_FAIL](state, error) {
    state.policySummarySettings.init = 2
    state.policySummarySettings.initErr = error
    state.policySummarySettings.menu = {}
  },
  [PREMINSTALBILL_SAVE_LOADING](state) {
    state.policy.premInstalBill.init = 0
    state.policy.premInstalBill.saving = true
    state.policy.premInstalBill.saveError.fieldMessages = []
    state.policy.premInstalBill.saveError.messages = []
  },
  [PREMINSTALBILL_SAVE_SUCCESS](state) {
    state.policy.premInstalBill.init = 1
    state.policy.premInstalBill.saving = false
    state.policy.premInstalBill.saveError.fieldMessages = []
    state.policy.premInstalBill.saveError.messages = []
  },
  [PREMINSTALBILL_SAVE_FAIL](state, errMsgs) {
    state.policy.premInstalBill.init = 2
    state.policy.premInstalBill.saving = false
    state.policy.premInstalBill.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.premInstalBill.saveError.messages = errMsgs.messages
  }
}
